import React from 'react';

var SvgWorkFilledIcon = function SvgWorkFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 5.5v-.25a2.25 2.25 0 0 1 2.25-2.25h2.5a2.25 2.25 0 0 1 2.25 2.25v.25h.25a3.25 3.25 0 0 1 3.25 3.25v5a3.25 3.25 0 0 1-3.25 3.25h-7.5a3.25 3.25 0 0 1-3.25-3.25v-5a3.25 3.25 0 0 1 3.25-3.25h.25Zm1.5-.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v.25h-4v-.25Zm-2.84 4.292a.625.625 0 0 1 .798-.381l.256.09c2.45.865 5.122.865 7.572 0l.256-.09a.625.625 0 1 1 .416 1.178l-.256.09a12.625 12.625 0 0 1-3.212.682.91.91 0 0 1 .01.139v.75a1 1 0 1 1-2 0v-.75c0-.047.003-.094.01-.14a12.622 12.622 0 0 1-3.212-.68l-.256-.09a.625.625 0 0 1-.381-.798Z"
  }));
};
SvgWorkFilledIcon.displayName = "WorkFilledIcon";

export { SvgWorkFilledIcon as S };
